const UNUSED_breakpoints = [375, 768, 992, 1200, 1860];

UNUSED_breakpoints.xs = UNUSED_breakpoints[0];
UNUSED_breakpoints.sm = UNUSED_breakpoints[1];
UNUSED_breakpoints.md = UNUSED_breakpoints[2];
UNUSED_breakpoints.lg = UNUSED_breakpoints[3];
UNUSED_breakpoints.xlg = UNUSED_breakpoints[4];

const breakpoints = {
  phone: 480,
  tabletPortrait: 768,
  tabletLandscape: 1024,
  desktop: 1280,
  bigDesktop: 1860,
};

export const mediaQueries = Object.entries(breakpoints).reduce(
  (acc, [key, value]) => {
    acc[key + 'Up'] = `min-width: ${value}px`;
    acc[key + 'Down'] = `max-width: ${value - 1}px`;

    return acc;
  },
  {}
);

export default UNUSED_breakpoints;
